import axios from 'axios';
import { proxyUrlMode as currentEnv } from '../setupEnvironment';

// prod => api, else => api-preprod (used only outside dev)
const host = currentEnv === 'prod' ? 'https://api.nike.com' : 'https://api-preprod.nike.com';

// In development we use the proxy path; in production we call real host
const baseURL = process.env.NODE_ENV === 'development' ? '/api/nike' : host;

const nikeClient = axios.create({
  baseURL,
  headers: {
    'nike-api-caller-id': 'com.nike:retail.sim',
    'Accept': 'application/json'
  }
});

// Optional logging
nikeClient.interceptors.response.use(
  r => r,
  e => {
    console.error('[Nike API]', e.config?.url, e.response?.status);
    return Promise.reject(e);
  }
);

export default nikeClient;